import { createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createBlock as _createBlock, mergeProps as _mergeProps, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-380400af"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "campaign-detail-swiper" }
const _hoisted_2 = { class: "images-container" }
const _hoisted_3 = ["id"]
const _hoisted_4 = ["id", "src", "alt"]
const _hoisted_5 = { class: "zoom-control-wrapper" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "pagination" }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "swiper-button-prev",
    "aria-hidden": "true"
  }),
  /*#__PURE__*/_createElementVNode("div", {
    class: "pagination_bullet",
    "aria-hidden": "true"
  }),
  /*#__PURE__*/_createElementVNode("div", {
    class: "swiper-button-next",
    "aria-hidden": "true"
  })
], -1 /* HOISTED */))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      class: "close-btn",
      type: "button",
      "aria-label": "닫기",
      onClick: $setup.emitOnClickCloseBtn
    }, [
      _createVNode($setup["InlineSvg"], {
        class: "close-image",
        src: require('@/assets/icons/x-icon.svg'),
        "aria-hidden": "true"
      }, null, 8 /* PROPS */, ["src"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode($setup["Swiper"], _mergeProps({ id: "image-swiper" }, $setup.swiperOptions, {
        onSlideChange: $setup.onSlideChange,
        onSwiper: $setup.onSwiper
      }), {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.campaignImages, (campaignImage, index) => {
            return (_openBlock(), _createBlock($setup["SwiperSlide"], {
              key: index,
              class: "image-slide"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", {
                  id: `campaign-${index}`
                }, [
                  _createElementVNode("img", {
                    id: `campaign-content-${index}`,
                    class: "image",
                    src: campaignImage.url,
                    alt: $setup.cardNewsImageAltText
                  }, null, 8 /* PROPS */, _hoisted_4)
                ], 8 /* PROPS */, _hoisted_3)
              ]),
              _: 2 /* DYNAMIC */
            }, 1024 /* DYNAMIC_SLOTS */))
          }), 128 /* KEYED_FRAGMENT */))
        ]),
        _: 1 /* STABLE */
      }, 16 /* FULL_PROPS */)
    ]),
    _createElementVNode("section", _hoisted_5, [
      _createVNode($setup["ZoomControl"], {
        ref: "zoomControl",
        "target-container-id": `campaign-${$setup.swiperRealIndex}`,
        "target-content-id": `campaign-content-${$setup.swiperRealIndex}`,
        onOnUpdatedZoom: $setup.onUpdatedZoom
      }, null, 8 /* PROPS */, ["target-container-id", "target-content-id"])
    ]),
    _hoisted_6
  ]))
}